export const initalMarkerConst = {
    marker: {
        location: "Champ de Mars, 5 Av. Anatole France, 75007 Paris, France",
        description: "",
        geometry: { lat: 48.85837009999999, lng: 2.2944813 },
    },
};
